import { createReducer, byIdAndValues } from 'src/utils/reducer'
import * as actions from 'src/constants/actionTypes'
import { CUSTOMER_ZONES_URL, DOCUMENTATION_URL } from 'src/constants/urls'
import uniq from 'lodash/uniq'

const documentation = createReducer(
    {
        id: null,
        byId: {},
        values: [],
        modalNewDocumentationOpen: false,
        modalEditDocumentationOpen: false,
        errors: {},
        loading: false,
        availability_zones: [],
        main_availability_zones: [],
    },
    {
        [actions.GET_DOCUMENTATIONS_SUCCESS]: (state, action) => {
            return {
                ...state,
                ...byIdAndValues(action.payload.data.results),
            }
        },
        [actions.GET_CUSTOMER_ZONES_SUCCESS]: (state, action) => {
            return {
                ...state,
                availability_zones: action.payload.data['availability_zones'],
                main_availability_zones:
                    action.payload.data['main_availability_zones'],
            }
        },
        [actions.SAVE_DOCUMENTATION]: (state) => {
            return {
                ...state,
                errors: {},
            }
        },
        [actions.SAVE_DOCUMENTATION_SUCCESS]: (state, action) => {
            const documentation = action.payload.data

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [documentation.id]: documentation,
                },
                values: uniq([...state.values, documentation.id]),
                modalNewDocumentationOpen: false,
            }
        },
        [actions.SAVE_DOCUMENTATION_ERROR]: (state, action) => {
            return {
                ...state,
                errors: action.error.response.data,
            }
        },
        [actions.DELETE_DOCUMENTATION_SUCCESS]: (state, action) => {
            const { byId, values } = state

            delete byId[action.id]

            return {
                ...state,
                byId: { ...byId },
                values: values.filter((id) => id !== action.id),
            }
        },
        [actions.OPEN_NEW_DOCUMENTATION_MODAL]: (state) => {
            return {
                ...state,
                modalNewDocumentationOpen: true,
                errors: {},
            }
        },
        [actions.CLOSE_NEW_DOCUMENTATION_MODAL]: (state) => {
            return {
                ...state,
                modalNewDocumentationOpen: false,
                errors: {},
            }
        },
        [actions.OPEN_EDIT_DOCUMENTATION_MODAL]: (state, action) => {
            const id = action.id

            return {
                ...state,
                id,
                modalEditDocumentationOpen: true,
                errors: {},
            }
        },
        [actions.CLOSE_EDIT_DOCUMENTATION_MODAL]: (state) => {
            return {
                ...state,
                modalEditDocumentationOpen: false,
                errors: {},
            }
        },
    }
)

export const getDocumentationsFromServer = (id) => {
    return {
        type: actions.API,
        method: 'get',
        payload: {
            url: `${DOCUMENTATION_URL}customer/${id}/`,
            start: () => ({
                type: actions.GET_DOCUMENTATIONS,
            }),
            success: (payload) => ({
                type: actions.GET_DOCUMENTATIONS_SUCCESS,
                payload,
            }),
            error: (error) => ({
                type: actions.GET_DOCUMENTATIONS_ERROR,
                error,
            }),
        },
    }
}

export const getZonesOfCustomer = (id) => {
    return {
        type: actions.API,
        method: 'get',
        payload: {
            url: `${CUSTOMER_ZONES_URL}${id}/`,
            start: () => ({
                type: actions.GET_CUSTOMER_ZONES,
            }),
            success: (payload) => ({
                type: actions.GET_CUSTOMER_ZONES_SUCCESS,
                payload,
            }),
            error: (error) => ({
                type: actions.GET_CUSTOMER_ZONES_ERROR,
                error,
            }),
        },
    }
}

export const saveDocumentation = (id, data) => {
    const method = id ? 'put' : 'post'
    const url = `${DOCUMENTATION_URL}${id ? id + '/' : ''}`

    return {
        type: actions.API,
        method,
        data,
        payload: {
            url,
            start: () => ({
                type: actions.SAVE_DOCUMENTATION,
            }),
            success: (payload) => {
                return {
                    type: actions.SAVE_DOCUMENTATION_SUCCESS,
                    payload,
                }
            },
            error: (error) => ({
                type: actions.SAVE_DOCUMENTATION_ERROR,
                error,
            }),
        },
    }
}

export const deleteDocumentation = (id) => {
    return {
        type: actions.API,
        method: 'delete',
        payload: {
            url: `${DOCUMENTATION_URL}${id}/`,
            start: () => ({
                type: actions.DELETE_DOCUMENTATION,
            }),
            success: (payload) => {
                return {
                    type: actions.DELETE_DOCUMENTATION_SUCCESS,
                    payload,
                    id,
                }
            },
            error: (error) => ({
                type: actions.DELETE_DOCUMENTATION_ERROR,
                error,
            }),
        },
    }
}

export const openNewDocumentationModal = () => ({
    type: actions.OPEN_NEW_DOCUMENTATION_MODAL,
})

export const closeNewDocumentationModal = () => ({
    type: actions.CLOSE_NEW_DOCUMENTATION_MODAL,
})

export const openEditDocumentationModal = (id) => ({
    type: actions.OPEN_EDIT_DOCUMENTATION_MODAL,
    id,
})

export const closeEditDocumentationModal = () => ({
    type: actions.CLOSE_EDIT_DOCUMENTATION_MODAL,
})

export const getDocumentationById = (state, id) =>
    state.cmdb.documentation.byId[id]

export const getDocumentations = (state) =>
    state.cmdb.documentation.values.map(
        (id) => state.cmdb.documentation.byId[id]
    )

export default documentation
